import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import logo from "../../assets/images/logo/app-logo.svg";
import Button from "../../components/global/button/Button";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import { changeUserPasswordService } from "../../services/api_services/DashboardServices";

export default function ChangePasswordModal(props) {
  const changePasswordSchema = Yup.object().shape({
    oldPassword: Yup.string()
      .required(`Old password is required`)
      .max(12, `Old password should be between 8 and 12 characters.`),
    newPassword: Yup.string()
      .required(`New password  is required`)
      .min(8, `Password should be between 8 and 12 characters.`)
      .max(12, `Password should be between 8 and 12 characters.`) 
      .test(
        'notSameAsOldPassword',
        'New password must not be the same as the old password',
        function (value) {
          return value !== this.parent.oldPassword;
        }
      ),
    confirmNewPassword: Yup.string()
      .required(`Confirm new password is required`)
      .min(8, `Confirm password should be between 8 and 12 characters.`)
      .max(12, `Confirm password should be between 8 and 12 characters.`)
      .oneOf([Yup.ref("newPassword")], "Passwords must match."),
  });

  const [isChangePasswordAPILoading, setIsChangePasswordAPILoading] =
    useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);

  async function changePasswordHandler(values) {
    setIsChangePasswordAPILoading(true);

    const reqBody = {
      ...values,
    };

    const response = await changeUserPasswordService(reqBody);

    if (response) {
      props.onHide();
      setIsChangePasswordAPILoading(false);
    }

    setIsChangePasswordAPILoading(false);
  }

  return (
    <Modal
      size="md"
      centered
      show={props.show}
      // onHide={props.onHide}
      dialogClassName=""
    >
      <ModalHeader className="justify-content-center">
        <div>
          <img src={logo} alt="" height="30" className="ms-4 text-center" />
          <h6 className="mb-0 mt-3 text-muted text-center">Change Password</h6>
        </div>
      </ModalHeader>

      <Formik
        initialValues={{
          oldPassword: "",
          newPassword: "",
          confirmNewPassword: "",
        }}
        validationSchema={changePasswordSchema}
        onSubmit={(values) => changePasswordHandler(values)}
      >
        {({ errors, touched, values }) => (
          <Form>
            <ModalBody>
              <div className="mt-3">
                <div className="form-floating mb-3">
                  <Field
                    className={`form-control ${
                      errors.oldPassword && touched.oldPassword && "is-invalid"
                    }`}
                    type={showOldPassword ? "text" : "password"}
                    id="oldPassword"
                    name="oldPassword"
                    placeholder="Old Password"
                    required
                  />

                  <label htmlFor="oldPassword">
                    <span>Old Password</span>
                  </label>

                  <div
                    className={`${
                      errors.oldPassword && touched.oldPassword
                        ? "invalid-feedback"
                        : "valid-feedback"
                    }`}
                  >
                    {errors.oldPassword}
                  </div>
                  <button
                    type="button"
                    className="password-toggle"
                    style={{
                      marginTop:
                        errors.oldPassword && touched.oldPassword && "0.4em",
                    }}
                    title={showOldPassword ? "Hide Password" : "Show Password"}
                    onClick={() => setShowOldPassword(!showOldPassword)}
                  >
                    {showOldPassword ? (
                      <i className="bi bi-eye-slash"></i>
                    ) : (
                      <i className="bi bi-eye"></i>
                    )}
                  </button>
                </div>
                <div className="form-floating mb-3">
                  <Field
                    className={`form-control ${
                      errors.newPassword && touched.newPassword && "is-invalid"
                    }`}
                    type={showNewPassword ? "text" : "password"}
                    id="newPassword"
                    name="newPassword"
                    placeholder="New Password"
                    required
                  />
                  <label htmlFor="newPassword">
                    <span>New Password</span>
                  </label>
                  <div
                    className={`${
                      errors.newPassword && touched.newPassword
                        ? "invalid-feedback"
                        : "valid-feedback"
                    }`}
                  >
                    {errors.newPassword}
                  </div>
                  <button
                    type="button"
                    className="password-toggle"
                    style={{
                      marginTop:
                        errors.newPassword && touched.newPassword && "0.4em",
                    }}
                    title={showNewPassword ? "Hide Password" : "Show Password"}
                    onClick={() => setShowNewPassword(!showNewPassword)}
                  >
                    {showNewPassword ? (
                      <i className="bi bi-eye-slash"></i>
                    ) : (
                      <i className="bi bi-eye"></i>
                    )}
                  </button>
                </div>
                <div className="form-floating mb-3">
                  <Field
                    className={`form-control ${
                      errors.confirmNewPassword &&
                      touched.confirmNewPassword &&
                      "is-invalid"
                    }`}
                    type={showConfirmNewPassword ? "text" : "password"}
                    id="confirmNewPassword"
                    name="confirmNewPassword"
                    placeholder="Confirm New Password"
                    required
                  />
                  <label htmlFor="confirmNewPassword">
                    <span>Confirm New Password</span>
                  </label>
                  <div
                    className={`${
                      errors.confirmNewPassword && touched.confirmNewPassword
                        ? "invalid-feedback"
                        : "valid-feedback"
                    }`}
                  >
                    {errors.confirmNewPassword}
                  </div>
                  <button
                    type="button"
                    className="password-toggle"
                    style={{
                      marginTop:
                        errors.confirmNewPassword &&
                        touched.confirmNewPassword &&
                        "0.4em",
                    }}
                    title={
                      showConfirmNewPassword ? "Hide Password" : "Show Password"
                    }
                    onClick={() =>
                      setShowConfirmNewPassword(!showConfirmNewPassword)
                    }
                  >
                    {showConfirmNewPassword ? (
                      <i className="bi bi-eye-slash"></i>
                    ) : (
                      <i className="bi bi-eye"></i>
                    )}
                  </button>
                </div>
              </div>
            </ModalBody>

            <ModalFooter>
              <Button
                isLoading={isChangePasswordAPILoading}
                disabled={isChangePasswordAPILoading}
              >
                Change Password
              </Button>
              <Button
                className="secondary outline"
                type="reset"
                onClick={() => {
                  props.onHide();
                }}
              >
                Cancel
              </Button>
            </ModalFooter>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}
